import React, { useState,useEffect } from 'react'
import {TextField} from '@material-ui/core'
import '../../../Css/UpdateForm_textTemplate.scss'

const UpdateForm_text = (props) => {
    const [state, setstate] = useState(null)

    useEffect(() => {
        props.onInput(state)
    }, [state])
    
    return(
        <div className="sectionPart"> 
            <label className = "judul">
                {props.updateLabel}     
            </label>              
            <form action="">
                <div className = "formWrapper">
                    <TextField 
                        name="InputName"
                        label={props.placeholder} 
                        type = {props.type}
                        value = {state}
                        onChange = {e =>setstate(e.target.value)}
                        />
                    <div className="buttonWrapper">
                        <button type="button" onClick = {(e)=>props.onClick(e)}>{props.updateButtonLabel}</button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default UpdateForm_text 